<!--
 * @Author: cyl
 * @Date: 2023-08-31 17:00:10
 * @LastEditors: ldx
 * @LastEditTime: 2023-12-21 20:40:51
 * @Description: 物联集控软件安装协议
-->
<template>
  <div class="page-container">
    <h3>重要声明</h3>
    <p>尊敬的用户：</p>
    <p>
      <strong>
        <u>
          {{
            activationCompany.company
          }}（以下简称“我们”），在此特别提醒，在您开始使用本功能时，请务必首先审慎阅读、充分理解本声明的全部内容。除非您已阅读并接受本规则中的所有条款，否则，您无权使用本功能。您实际使用本服务的行为将视为您已阅读并同意本声明规则的约束。如果您对本声明内容有任何的疑问，请勿进行下一步的操作。您可以在使用前寻求我们客服的解释和帮助，以便我们向您进行说明。
        </u>
      </strong>
    </p>
    <p>1. 您应当对您的帐号密码进行妥善保管，不得提供给任何其他人士使用、控制。</p>
    <p>
      2.
      本系统的功能仅限于对您上传的应用程序/软件的安装文件进行自动化运作直至安装完成，从而提升安装效率。我们不会、也不能对您上传的应用程序/软件安装包进行任何的修改、编辑或整理等操作。
    </p>
    <p>
      <strong><u>3.敬请知悉：</u></strong>
      您上传的应用程序/软件的安装文件应当是合法正当的，且须确保来自于该应用程序/软件的官方下载渠道。因安装文件本身的问题导致的应用程序/软件安装失败或不能正常使用，以及安装的恶意应用程序/软件而导致平台系统发生的后果、责任由您独立承担，我们因此遭受损失的，您应当一并赔偿。
    </p>
    <p>
      4.
      为确保系统的安全运行，我们保留权利对您上传的应用程序/软件进行适当的检测或评估并基于其结果作出上传限制/禁止、功能使用限制/禁止等决定。但您同意，这类检测和评估并不当然构成我们的法定或合同义务。
    </p>
    <p>
      5.
      您知悉、理解并同意接受，您所上传的应用程序/软件安装包及其对应的应用程序，可能会和智能终端硬件或系统发生不兼容和不适配的情况，且安装时和系统兼容且适配的应用程序/软件也可能随着系统的更新和调整而发生不兼容和适配的情况。故，因此而发生的安全性或适配性问题，是我们无法保证的内容，您因此而遭受的损失（例如文件受损、丢失）与我们无关。
    </p>
    <p>6. 鉴于本功能特殊性及额外附加性，我们有权在无需通知您的情况下，暂停、中止或终止部分或全部的功能服务，在此情况下，您可能无法在下次继续使用本功能服务。</p>
    <p>7. 您不得利用本功能从事国家规定的不合法行为以及违反和所签署的相关合同协议。</p>

    <P>{{ activationCompany.address }}</P>
    <P>2023年8月31日</P>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.page-container {
  padding: 0 16px;

  h3 {
    font-size: 16px;
    text-align: center;
  }

  p {
    font-size: 14px;
  }
}
</style>
